// React
import React from 'react';

// Styles
import '../styles/PauseTimerPopUp.css';

// Components
import MissionHeader from './MissionHeader';
import MainButton from './MainButton';

// Contexts
import { useTimer } from '../contextes/useTimer';

// Props du composant PauseTimerPopUp
type PauseTimerPopUpProps = {
    setIsPaused?: React.Dispatch<React.SetStateAction<boolean>>;
};

// Composant pour afficher une popup de pause du timer
const PauseTimerPopUp: React.FC<PauseTimerPopUpProps> = ({ setIsPaused }) => {
    // Import du timer depuis le contexte
    const { time, formatTime, startTimer } = useTimer();

    // Handler pour le bouton "Reprendre"
    const handleReprendreButtonClick = () => {
        if (setIsPaused) {
            setIsPaused(false);
            startTimer();
        }
    };
    return (
        <div className='popup pause-popup'>
            <div className='pause-popup-gradient'></div>
            <MissionHeader
                showBackButton={false}
                showSettingsButton={false}
                logoVariant='alternate'
            />
            <div className='pause-popup-content'>
                <img
                    src='./images/timer-icon-alternate.png'
                    alt='Timer'
                    className=''
                />
                <h1>
                    <span>Le jeu est en</span> pause
                </h1>
                <p>
                    Il vous reste <span>{formatTime(time)} min</span>
                </p>
            </div>
            <MainButton
                text='Reprendre'
                backgroundColor={'primary'}
                onClick={handleReprendreButtonClick}
            />
            <div className='pause-popup-gradient-2'></div>
        </div>
    );
};

export default PauseTimerPopUp;
